import { render, staticRenderFns } from "./Send-Mail.vue?vue&type=template&id=4df7bf90&scoped=true"
import script from "./Send-Mail.vue?vue&type=script&lang=js"
export * from "./Send-Mail.vue?vue&type=script&lang=js"
import style0 from "./Send-Mail.vue?vue&type=style&index=0&id=4df7bf90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df7bf90",
  null
  
)

export default component.exports